import React from "react";
import s from "./FavoriteSearchCard.module.css";

interface Props {
	id: string;
}

function SearchCardSvgSelector({ id }: Props) {
	switch (id) {
		case "notNew":
			return (
				<svg
					width="45"
					height="20"
					viewBox="0 0 45 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect width="45" height="20" rx="10" fill="#DADADA" />
					<path
						d="M14.112 8.996V6.56H18.924V5.6H13.104V14H16.344C17.892 14 19.572 13.556 19.572 11.504C19.572 9.452 17.892 8.996 16.344 8.996H14.112ZM14.112 13.04V9.956H16.392C17.448 9.956 18.552 10.124 18.552 11.504C18.552 12.872 17.46 13.04 16.392 13.04H14.112ZM21.2162 14.696L24.7922 4.904H24.0722L20.4962 14.696H21.2162ZM29.8544 12.092L32.9144 5.6H31.8344L29.4104 10.82L26.5184 5.6H25.4024L28.8704 11.768L28.7264 12.08C28.2104 13.064 27.6464 13.184 27.0344 13.184C26.6984 13.184 26.3504 13.112 26.0744 13.028V13.976C26.4344 14.084 26.8424 14.144 27.2144 14.144C28.1384 14.144 29.0744 13.736 29.8544 12.092Z"
						fill="black"
					/>
				</svg>
			);
		case "heart":
			return (
				<svg
					style={{ cursor: "pointer" }}
					width="21"
					height="19"
					viewBox="0 0 21 19"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M19.0676 1.68064C18.5493 1.14756 17.934 0.724745 17.2568 0.436372C16.5796 0.147999 15.8537 -0.000282692 15.1208 4.04595e-07C14.3878 0.000283501 13.6621 0.149126 12.9851 0.438022C12.3081 0.726918 11.6931 1.1502 11.1752 1.68369L10.4992 2.3875L9.82884 1.68521L9.82448 1.68073C9.30646 1.1479 8.69147 0.725227 8.01464 0.436858C7.33781 0.14849 6.61238 6.82949e-05 5.87979 6.82949e-05C5.14719 6.82949e-05 4.42176 0.14849 3.74493 0.436858C3.0681 0.725227 2.45311 1.1479 1.93509 1.68073L1.63393 1.9905C0.587743 3.0666 0 4.5261 0 6.04793C0 7.56977 0.587743 9.02927 1.63393 10.1054L9.58229 18.2808L10.4799 19.2482L10.5013 19.2261L10.5245 19.25L11.3655 18.3373L19.3687 10.1052C20.4133 9.02828 21 7.5691 21 6.0478C21 4.5265 20.4133 3.06732 19.3687 1.99036L19.0676 1.68064ZM18.3823 9.09089L10.5013 17.1974L2.62004 9.09089C1.8354 8.28382 1.3946 7.18919 1.3946 6.04782C1.3946 4.90645 1.8354 3.81183 2.62004 3.00475L2.92124 2.69498C3.7055 1.88831 4.76906 1.43494 5.87817 1.43451C6.98728 1.43408 8.05117 1.88663 8.83602 2.6927L10.4962 4.43147L12.1643 2.69498C12.5528 2.29536 13.0141 1.97836 13.5217 1.76208C14.0293 1.5458 14.5734 1.43449 15.1228 1.43449C15.6723 1.43449 16.2164 1.5458 16.724 1.76208C17.2316 1.97836 17.6928 2.29536 18.0814 2.69498L18.3825 3.00471C19.166 3.81244 19.6059 4.90685 19.6059 6.04784C19.6059 7.18882 19.1658 8.2832 18.3823 9.09089Z" />
				</svg>
			);
		case "littleHeart":
			return (
				<svg
					width="16"
					height="14"
					viewBox="0 0 16 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M11.6394 0C10.3083 0 9.03072 0.618211 8.19687 1.59453C7.36302 0.618211 6.08547 0 4.75437 0C2.39818 0 0.546875 1.84653 0.546875 4.19632C0.546875 7.08032 3.14788 9.4301 7.08763 13.0008L8.19687 14L9.30612 12.9927C13.2459 9.4301 15.8469 7.08105 15.8469 4.19632C15.8469 1.84579 13.9956 0 11.6394 0ZM8.27338 11.8632L8.19687 11.9398L8.12037 11.8639C4.47897 8.57537 2.07687 6.40095 2.07687 4.19632C2.07687 2.67032 3.22437 1.52526 4.75437 1.52526C5.93247 1.52526 7.07997 2.28053 7.48542 3.32537H8.91597C9.31377 2.28053 10.4613 1.52526 11.6394 1.52526C13.1694 1.52526 14.3169 2.66958 14.3169 4.19558C14.3169 6.40021 11.9148 8.57463 8.27338 11.8632Z"
						fill="#FFD74A"
					/>
				</svg>
			);
		case "topFlag":
			return (
				<svg
					width="63"
					height="17"
					viewBox="0 0 63 17"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M0 0H63L58.5789 8.5L63 17H0V0Z" fill="#FFF3C9" />
					<path
						d="M11.14 5V5.8H13.6V12H14.44V5.8H16.9V5H11.14ZM17.1336 8.5C17.1336 10.31 18.3436 12.12 20.7936 12.12C23.2436 12.12 24.4536 10.31 24.4536 8.5C24.4536 6.69 23.2436 4.88 20.7936 4.88C18.3436 4.88 17.1336 6.69 17.1336 8.5ZM23.6036 8.5C23.6036 9.94 22.6936 11.32 20.7936 11.32C18.8936 11.32 17.9836 9.94 17.9836 8.5C17.9836 7.06 18.8936 5.68 20.7936 5.68C22.6936 5.68 23.6036 7.06 23.6036 8.5ZM26.6663 12V5.8H30.6963V12H31.5363V5H25.8263V12H26.6663ZM37.1253 5.2L35.4753 5.83V6.63L36.9053 6.09V11.2H35.4753V12H39.0153V11.2H37.7453V5.2H37.1253ZM39.7522 8.6C39.7522 10.61 40.6922 12.12 42.7522 12.12C44.8222 12.12 45.7622 10.61 45.7622 8.6C45.7622 6.59 44.8222 5.08 42.7522 5.08C40.6922 5.08 39.7522 6.59 39.7522 8.6ZM44.9122 8.6C44.9122 10.3 44.2422 11.32 42.7522 11.32C41.2722 11.32 40.6022 10.3 40.6022 8.6C40.6022 6.9 41.2722 5.88 42.7522 5.88C44.2422 5.88 44.9122 6.9 44.9122 8.6ZM46.7834 8.6C46.7834 10.61 47.7234 12.12 49.7834 12.12C51.8534 12.12 52.7934 10.61 52.7934 8.6C52.7934 6.59 51.8534 5.08 49.7834 5.08C47.7234 5.08 46.7834 6.59 46.7834 8.6ZM51.9434 8.6C51.9434 10.3 51.2734 11.32 49.7834 11.32C48.3034 11.32 47.6334 10.3 47.6334 8.6C47.6334 6.9 48.3034 5.88 49.7834 5.88C51.2734 5.88 51.9434 6.9 51.9434 8.6Z"
						fill="#2B2A38"
					/>
				</svg>
			);
		case "topFlagLittle":
			return (
				<svg
					width="34"
					height="12"
					viewBox="0 0 34 12"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M0 0H34L31.614 6L34 12H0V0Z" fill="#FFF3C9" />
					<path
						d="M5.112 3.93125H9.72V4.57125H7.752V9.53125H7.08V4.57125H5.112V3.93125ZM10.0909 7.79525C9.96821 7.45392 9.90688 7.09925 9.90688 6.73125C9.90688 6.36325 9.96821 6.00858 10.0909 5.66725C10.2189 5.32592 10.4002 5.01925 10.6349 4.74725C10.8695 4.46992 11.1762 4.24858 11.5549 4.08325C11.9335 3.91792 12.3602 3.83525 12.8349 3.83525C13.3095 3.83525 13.7362 3.91792 14.1149 4.08325C14.4935 4.24858 14.8002 4.46992 15.0349 4.74725C15.2695 5.01925 15.4482 5.32592 15.5709 5.66725C15.6989 6.00858 15.7629 6.36325 15.7629 6.73125C15.7629 7.09925 15.6989 7.45392 15.5709 7.79525C15.4482 8.13658 15.2695 8.44592 15.0349 8.72325C14.8002 8.99525 14.4935 9.21392 14.1149 9.37925C13.7362 9.54458 13.3095 9.62725 12.8349 9.62725C12.3602 9.62725 11.9335 9.54458 11.5549 9.37925C11.1762 9.21392 10.8695 8.99525 10.6349 8.72325C10.4002 8.44592 10.2189 8.13658 10.0909 7.79525ZM14.9389 7.57125C15.0349 7.30458 15.0829 7.02458 15.0829 6.73125C15.0829 6.43792 15.0349 6.15792 14.9389 5.89125C14.8482 5.62458 14.7122 5.38458 14.5309 5.17125C14.3549 4.95792 14.1202 4.78992 13.8269 4.66725C13.5335 4.53925 13.2029 4.47525 12.8349 4.47525C12.4669 4.47525 12.1362 4.53925 11.8429 4.66725C11.5495 4.78992 11.3122 4.95792 11.1309 5.17125C10.9549 5.38458 10.8189 5.62458 10.7229 5.89125C10.6322 6.15792 10.5869 6.43792 10.5869 6.73125C10.5869 7.02458 10.6322 7.30458 10.7229 7.57125C10.8189 7.83792 10.9549 8.07792 11.1309 8.29125C11.3122 8.50458 11.5495 8.67525 11.8429 8.80325C12.1362 8.92592 12.4669 8.98725 12.8349 8.98725C13.2029 8.98725 13.5335 8.92592 13.8269 8.80325C14.1202 8.67525 14.3549 8.50458 14.5309 8.29125C14.7122 8.07792 14.8482 7.83792 14.9389 7.57125ZM17.533 9.53125H16.861V3.93125H21.429V9.53125H20.757V4.57125H17.533V9.53125Z"
						fill="#2B2A38"
					/>
				</svg>
			);
		case "yellowHeart":
			return (
				<svg
					style={{ cursor: "pointer" }}
					width="21"
					height="19"
					viewBox="0 0 21 19"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M10.5 19L8.9775 17.6332C3.57 12.7978 0 9.59836 0 5.69482C0 2.49537 2.541 0 5.775 0C7.602 0 9.3555 0.838692 10.5 2.15368C11.6445 0.838692 13.398 0 15.225 0C18.459 0 21 2.49537 21 5.69482C21 9.59836 17.43 12.7978 12.0225 17.6332L10.5 19Z"
						fill="#FFD74A"
					/>
				</svg>
			);
		case "orangeHeart":
			return (
				<svg
					width="42"
					height="42"
					viewBox="0 0 42 42"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect width="42" height="42" rx="21" fill="#FF9B68" />
					<path
						d="M31.6995 12.008C31.0825 11.3711 30.35 10.8659 29.5438 10.5214C28.7376 10.1768 27.8735 9.99966 27.0009 10C26.1284 10.0003 25.2644 10.1782 24.4585 10.5234C23.6526 10.8685 22.9204 11.3743 22.3039 12.0117L21.4991 12.8526L20.701 12.0135L20.6958 12.0081C20.0791 11.3715 19.347 10.8665 18.5412 10.522C17.7355 10.1774 16.8719 10.0001 15.9997 10.0001C15.1276 10.0001 14.264 10.1774 13.4583 10.522C12.6525 10.8665 11.9204 11.3715 11.3037 12.0081L10.9452 12.3783C9.69969 13.664 9 15.4078 9 17.2261C9 19.0444 9.69969 20.7882 10.9452 22.0739L20.4075 31.842L21.476 32.9978L21.5015 32.9715L21.5292 33L22.5303 31.9095L32.058 22.0738C33.3016 20.787 34 19.0436 34 17.2259C34 15.4083 33.3016 13.6648 32.058 12.3781L31.6995 12.008ZM30.8837 20.8618L21.5015 30.5476L12.1191 20.8618C11.185 19.8975 10.6602 18.5897 10.6602 17.226C10.6602 15.8623 11.185 14.5544 12.1191 13.5901L12.4777 13.22C13.4113 12.2562 14.6775 11.7145 15.9978 11.714C17.3182 11.7134 18.5847 12.2542 19.5191 13.2172L21.4955 15.2947L23.4813 13.22C23.9439 12.7425 24.4929 12.3637 25.0973 12.1053C25.7016 11.8469 26.3493 11.7139 27.0034 11.7139C27.6575 11.7139 28.3052 11.8469 28.9095 12.1053C29.5138 12.3637 30.0629 12.7425 30.5254 13.22L30.884 13.59C31.8166 14.5551 32.3404 15.8627 32.3404 17.226C32.3403 18.5892 31.8165 19.8968 30.8837 20.8618Z"
						fill="white"
					/>
				</svg>
			);
		case "orangeHeartActive":
			return (
				<svg
					width="42"
					height="42"
					viewBox="0 0 42 42"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0 20.9961C0 9.39811 9.40202 -0.00390625 21 -0.00390625V-0.00390625C32.598 -0.00390625 42 9.39811 42 20.9961V20.9961C42 32.5941 32.598 41.9961 21 41.9961V41.9961C9.40202 41.9961 0 32.5941 0 20.9961V20.9961Z"
						fill="#FF9B68"
					/>
					<path
						d="M31.4885 11.0041C30.8715 10.3672 30.139 9.86202 29.3328 9.51747C28.5266 9.17292 27.6626 8.99576 26.79 8.99609C25.9174 8.99643 25.0535 9.17427 24.2476 9.51944C23.4416 9.86462 22.7095 10.3704 22.0929 11.0078L21.2881 11.8487L20.4901 11.0096L20.4849 11.0042C19.8682 10.3676 19.1361 9.8626 18.3303 9.51805C17.5245 9.17351 16.6609 8.99618 15.7888 8.99618C14.9167 8.99618 14.0531 9.17351 13.2473 9.51805C12.4416 9.8626 11.7094 10.3676 11.0927 11.0042L10.7342 11.3744C9.48876 12.6601 8.78906 14.4039 8.78906 16.2222C8.78906 18.0405 9.48876 19.7843 10.7342 21.07L20.1966 30.8381L21.2651 31.9939L21.2906 31.9675L21.3182 31.9961L22.3194 30.9056L31.8471 21.0699C33.0907 19.7831 33.7891 18.0397 33.7891 16.222C33.7891 14.4044 33.0907 12.6609 31.8471 11.3742L31.4885 11.0041ZM22 13.5L21.3182 14L21.7891 14.5H22.3194C21.3853 13.5357 29.2891 17.3637 29.2891 16C29.2891 14.6363 29.355 16.9643 30.2891 16H29.7891C30.7227 15.0362 22.9687 14.5005 24.2891 14.5C25.6094 14.4995 18.3738 11.2502 19.3081 12.2133L21.3182 14L23.2704 12.2161C23.7329 11.7386 20.8649 13.8249 21.4693 13.5665C20.8151 13.5665 22.0736 13.3081 21.4693 13.5665C22.1234 13.5665 23.2623 14.6037 21.3182 14C30.7891 13.5 21.0067 13.089 21.4693 13.5665L21.3182 14C21.3183 12.6367 22.2509 14.9651 21.3182 14C21.3182 15.3633 22.9327 12.535 22 13.5Z"
						fill="white"
					/>
				</svg>
			);

		case "greenCart":
			return (
				<svg
					width="25"
					height="18"
					viewBox="0 0 25 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M10.5243 17.9988C11.5754 17.9988 12.4275 17.1911 12.4275 16.1947C12.4275 15.1983 11.5754 14.3906 10.5243 14.3906C9.47319 14.3906 8.62109 15.1983 8.62109 16.1947C8.62109 17.1911 9.47319 17.9988 10.5243 17.9988Z"
						fill="#0BB82E"
					/>
					<path
						d="M19.4891 17.9988C20.5403 17.9988 21.3924 17.1911 21.3924 16.1947C21.3924 15.1983 20.5403 14.3906 19.4891 14.3906C18.438 14.3906 17.5859 15.1983 17.5859 16.1947C17.5859 17.1911 18.438 17.9988 19.4891 17.9988Z"
						fill="#0BB82E"
					/>
					<path
						d="M11.5334 13.0383C10.2202 13.0383 9.02121 12.2986 8.50734 11.1079L4.5677 1.96107C4.37738 1.51005 3.88254 1.23943 3.38771 1.29355C3.36868 1.29355 3.34965 1.29355 3.33061 1.29355L0.685155 1.32964C0.685155 1.32964 0.685155 1.32964 0.666123 1.32964C0.304513 1.32964 0 1.04098 0 0.698201C0 0.355421 0.285481 0.0667649 0.647091 0.0487239L3.25449 0.0126418C4.33931 -0.0956043 5.38608 0.49975 5.78575 1.47396L9.72539 10.6388C10.068 11.4326 10.9434 11.9017 11.838 11.7573L17.9473 10.8373C19.3747 10.6208 20.5927 9.70067 21.1256 8.41976L23.5998 2.57447C23.6759 2.39406 23.6569 2.19561 23.5427 2.0152C23.4285 1.85283 23.2572 1.76262 23.0669 1.76262L11.0386 3.29611C10.677 3.35023 10.3344 3.09766 10.2964 2.75488C10.2393 2.4121 10.5057 2.08736 10.8673 2.05128L22.9527 0.51779C22.9908 0.51779 23.0098 0.51779 23.0478 0.51779C23.6949 0.51779 24.304 0.824488 24.6656 1.32964C25.0272 1.83478 25.1033 2.48426 24.8559 3.06157L22.3817 8.90687C21.6775 10.5847 20.0598 11.8115 18.1566 12.1001L12.0473 13.0022C11.876 13.0383 11.7047 13.0383 11.5334 13.0383Z"
						fill="#0BB82E"
					/>
				</svg>
			);
		case "location":
			return (
				<svg
					width="11"
					height="15"
					viewBox="0 0 11 15"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M5.5 0C2.46728 0 0 2.43698 0 5.43241C0 9.14984 4.92196 14.6072 5.13152 14.8377C5.32835 15.0543 5.67201 15.0539 5.86848 14.8377C6.07804 14.6072 11 9.14984 11 5.43241C10.9999 2.43698 8.53269 0 5.5 0ZM5.5 13.7616C3.84351 11.8181 0.990449 7.98376 0.990449 5.43247C0.990449 2.97639 3.01341 0.978282 5.5 0.978282C7.98659 0.978282 10.0096 2.97639 10.0096 5.43244C10.0095 7.98385 7.15691 11.8175 5.5 13.7616Z"
						fill="#727272"
					/>
					<path
						d="M5.5 2.69924C3.97417 2.69924 2.73284 3.92535 2.73284 5.43244C2.73284 6.93953 3.97419 8.16563 5.5 8.16563C7.02581 8.16563 8.26713 6.93953 8.26713 5.43244C8.26713 3.92535 7.02581 2.69924 5.5 2.69924ZM5.5 7.18735C4.52029 7.18735 3.72329 6.40012 3.72329 5.43244C3.72329 4.46476 4.52032 3.67752 5.5 3.67752C6.47968 3.67752 7.27671 4.46476 7.27671 5.43244C7.27671 6.40012 6.47968 7.18735 5.5 7.18735Z"
						fill="#727272"
					/>
				</svg>
			);
		case "location_white":
			return (
				<svg
					width="11"
					height="15"
					viewBox="0 0 11 15"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M5.5 0C2.46728 0 0 2.28466 0 5.09288C0 8.57797 4.92196 13.6943 5.13152 13.9104C5.32835 14.1134 5.67201 14.113 5.86848 13.9104C6.07804 13.6943 11 8.57797 11 5.09288C10.9999 2.28466 8.53269 0 5.5 0ZM5.5 12.9015C3.84351 11.0795 0.990449 7.48477 0.990449 5.09294C0.990449 2.79037 3.01341 0.91714 5.5 0.91714C7.98659 0.91714 10.0096 2.79037 10.0096 5.09291C10.0095 7.48486 7.15691 11.0789 5.5 12.9015Z"
						fill="white"
					/>
					<path
						d="M5.5 2.53054C3.97416 2.53054 2.73284 3.68001 2.73284 5.09291C2.73284 6.50581 3.97419 7.65528 5.5 7.65528C7.02581 7.65528 8.26713 6.50581 8.26713 5.09291C8.26713 3.68001 7.02581 2.53054 5.5 2.53054ZM5.5 6.73814C4.52029 6.73814 3.72329 6.00011 3.72329 5.09291C3.72329 4.18571 4.52032 3.44768 5.5 3.44768C6.47968 3.44768 7.27671 4.18571 7.27671 5.09291C7.27671 6.00011 6.47968 6.73814 5.5 6.73814Z"
						fill="white"
					/>
				</svg>
			);
		case "delCardButton":
			return (
				<svg
					className={s.delSvg}
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle cx="10" cy="10" r="9.5" />
					<line
						x1="5.83301"
						y1="9.83594"
						x2="14.9997"
						y2="9.83594"
						strokeWidth="2"
					/>
				</svg>
			);
		case "cardMenuIcon":
			return (
				<svg
					className={s.delSvg}
					width="20"
					height="20"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle cx="12" cy="12" r="11.5" />
					<line x1="7" y1="12" x2="18" y2="12" strokeWidth="2" />
				</svg>
			);
		case "phone":
			return (
				<svg
					width="14"
					height="13"
					viewBox="0 0 14 13"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M2.90337 0.0472282L2.06486 0.0015189C1.80149 -0.0128514 1.54315 0.0751568 1.34407 0.248088C0.937564 0.601094 0.28757 1.28356 0.0879285 2.1729C-0.209789 3.49895 0.250306 5.12271 1.44109 6.74648C2.63188 8.37024 4.851 10.9683 8.77507 12.0779C10.0396 12.4354 11.0343 12.1944 11.8018 11.7034C12.4096 11.3146 12.8286 10.6905 12.9796 9.98499L13.1135 9.35968C13.1561 9.16093 13.0552 8.95926 12.8705 8.87418L10.0367 7.56794C9.85268 7.48318 9.63453 7.53676 9.5108 7.69711L8.39828 9.13934C8.31425 9.24829 8.17038 9.29148 8.04048 9.24586C7.27861 8.9781 4.72654 7.90925 3.3262 5.21186C3.26547 5.09486 3.28057 4.95287 3.36672 4.85309L4.42996 3.62308C4.53859 3.49749 4.56603 3.3209 4.50075 3.16827L3.2792 0.310359C3.21416 0.158212 3.06843 0.0562401 2.90337 0.0472282Z"
						fill="white"
					/>
				</svg>
			);

		default:
			return <svg></svg>;
	}
}

export default SearchCardSvgSelector;
